import { Box, Typography, Card, CardContent } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';

export default function Roadmap() {
  return (
    <Box>
      <Typography variant="h5" fontWeight={600} mb={1}>Roadmap</Typography>
      <Typography variant="body2" color="text.secondary" mb={4}>
        Acompanhe as próximas funcionalidades do sistema
      </Typography>
      <Card>
        <CardContent sx={{ textAlign: 'center', py: 6 }}>
          <ConstructionIcon sx={{ fontSize: 60, color: '#ccc', mb: 2 }} />
          <Typography variant="h6" color="text.secondary" mb={1}>
            Em construção
          </Typography>
          <Typography variant="body2" color="text.secondary">
            O Roadmap do sistema está sendo preparado e estará disponível em breve.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}